// extracted by mini-css-extract-plugin
export default {"arrow":"Arrows_arrow__JCSmV","arrow_left":"Arrows_arrow_left__xERej","arrow_right":"Arrows_arrow_right__c9Odm"};